import type { ProfileCompletionItemKey } from 'src/redux/types/candidateProfile';

/** Short names for checklist items, for chips and change toasts. */
const PROFILE_ITEM_SHORT_NAMES: Record<ProfileCompletionItemKey, string> = {
  resume: 'Resume',
  education: 'Education',
  experience: 'Experience',
  projects: 'Projects',
  about: 'Summary',
  skills: 'Skills',
  preferences: 'Job preferences',
  photo: 'Photo',
  links: 'Portfolio link',
};

export default PROFILE_ITEM_SHORT_NAMES;
